// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Security control tree — vertical outline used in the PDF export */

.sto {
  font-family: Lato, sans-serif;
  color: #0b1e2d;
}

.sto-root {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border: 1px solid #e3eaee;
  border-radius: 12px;
  background: linear-gradient(90deg, #f3f6fb 0%, #f7fbfa 100%);
}

.sto-root-mark {
  flex: none;
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #00146d;
  color: #ffffff;
}

.sto-root-text {
  flex: 1 1 220px;
  min-width: 0;
}

.sto-root-eyebrow {
  margin: 0 0 2px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #5f7484;
}

.sto-root h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.sto-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
}

.sto-stats span {
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  padding: 4px 8px;
  border: 1px solid #e3eaee;
  border-radius: 999px;
  background: #ffffff;
  font-size: 11px;
  color: #5f7484;
  white-space: nowrap;
}

.sto-stats strong {
  font-size: 14px;
  font-weight: 800;
  color: #0b1e2d;
}

.sto-stats span.is-warn strong {
  color: #c98a16;
}

/* Branches + connectors */
.sto-branches {
  list-style: none;
  margin: 12px 0 0 18px;
  padding: 0 0 0 24px;
}

.sto-node {
  position: relative;
  padding-bottom: 10px;
}

.sto-node:last-child {
  padding-bottom: 0;
}

.sto-node::before {
  content: '';
  position: absolute;
  left: -24px;
  top: -12px;
  bottom: 0;
  border-left: 2px solid #d5e0e4;
}

.sto-node:last-child::before {
  bottom: auto;
  height: 36px;
}

.sto-node::after {
  content: '';
  position: absolute;
  left: -24px;
  top: 24px;
  width: 20px;
  border-top: 2px solid #d5e0e4;
}

.sto-card {
  border: 1px solid #e3eaee;
  border-left: 3px solid #0d9b87;
  border-radius: 10px;
  background: #ffffff;
}

.sto-node.is-uncovered .sto-card {
  border-left-color: #c98a16;
}

.sto-card-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
}

.sto-code {
  flex: none;
  min-width: 30px;
  padding: 3px 8px;
  border-radius: 6px;
  background: #eef2f8;
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: 11px;
  font-weight: 700;
  color: #00146d;
  text-align: center;
  line-height: 1.5;
}

.sto-card-text {
  flex: 1 1;
  min-width: 0;
}

.sto-title {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.sto-desc {
  margin: 4px 0 0;
  font-size: 11.5px;
  line-height: 1.5;
  color: #5f7484;
  overflow-wrap: anywhere;
}

.sto-pill {
  flex: none;
  padding: 3px 10px;
  border-radius: 999px;
  background: #e7f5f2;
  font-size: 11.5px;
  font-weight: 700;
  color: #0d9b87;
  white-space: nowrap;
}

.sto-pill.is-warn {
  background: #fbf3e4;
  color: #c98a16;
}

/* Existing controls (leaves) */
.sto-leaves {
  list-style: none;
  margin: 0;
  padding: 4px 14px 12px 54px;
  border-top: 1px dashed #e3eaee;
}

.sto-leaf {
  display: flex;
  gap: 10px;
  padding: 8px 0;
}

.sto-leaf + .sto-leaf {
  border-top: 1px solid #f0f4f6;
}

.sto-leaf-dot {
  flex: none;
  width: 8px;
  height: 8px;
  margin-top: 6px;
  border-radius: 50%;
  background: #0d9b87;
}

.sto-leaf-title {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.sto-leaf-desc {
  margin: 2px 0 0;
  font-size: 11.5px;
  line-height: 1.5;
  color: #5f7484;
  overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/security-tree-outline.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB","sourcesContent":["/* Security control tree — vertical outline used in the PDF export */\n\n.sto {\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n}\n\n.sto-root {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 14px;\n  border: 1px solid #e3eaee;\n  border-radius: 12px;\n  background: linear-gradient(90deg, #f3f6fb 0%, #f7fbfa 100%);\n}\n\n.sto-root-mark {\n  flex: none;\n  display: grid;\n  place-items: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  background: #00146d;\n  color: #ffffff;\n}\n\n.sto-root-text {\n  flex: 1 1 220px;\n  min-width: 0;\n}\n\n.sto-root-eyebrow {\n  margin: 0 0 2px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #5f7484;\n}\n\n.sto-root h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n}\n\n.sto-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.sto-stats span {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 5px;\n  padding: 4px 8px;\n  border: 1px solid #e3eaee;\n  border-radius: 999px;\n  background: #ffffff;\n  font-size: 11px;\n  color: #5f7484;\n  white-space: nowrap;\n}\n\n.sto-stats strong {\n  font-size: 14px;\n  font-weight: 800;\n  color: #0b1e2d;\n}\n\n.sto-stats span.is-warn strong {\n  color: #c98a16;\n}\n\n/* Branches + connectors */\n.sto-branches {\n  list-style: none;\n  margin: 12px 0 0 18px;\n  padding: 0 0 0 24px;\n}\n\n.sto-node {\n  position: relative;\n  padding-bottom: 10px;\n}\n\n.sto-node:last-child {\n  padding-bottom: 0;\n}\n\n.sto-node::before {\n  content: '';\n  position: absolute;\n  left: -24px;\n  top: -12px;\n  bottom: 0;\n  border-left: 2px solid #d5e0e4;\n}\n\n.sto-node:last-child::before {\n  bottom: auto;\n  height: 36px;\n}\n\n.sto-node::after {\n  content: '';\n  position: absolute;\n  left: -24px;\n  top: 24px;\n  width: 20px;\n  border-top: 2px solid #d5e0e4;\n}\n\n.sto-card {\n  border: 1px solid #e3eaee;\n  border-left: 3px solid #0d9b87;\n  border-radius: 10px;\n  background: #ffffff;\n}\n\n.sto-node.is-uncovered .sto-card {\n  border-left-color: #c98a16;\n}\n\n.sto-card-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 14px;\n}\n\n.sto-code {\n  flex: none;\n  min-width: 30px;\n  padding: 3px 8px;\n  border-radius: 6px;\n  background: #eef2f8;\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-size: 11px;\n  font-weight: 700;\n  color: #00146d;\n  text-align: center;\n  line-height: 1.5;\n}\n\n.sto-card-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.sto-title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.4;\n  overflow-wrap: anywhere;\n}\n\n.sto-desc {\n  margin: 4px 0 0;\n  font-size: 11.5px;\n  line-height: 1.5;\n  color: #5f7484;\n  overflow-wrap: anywhere;\n}\n\n.sto-pill {\n  flex: none;\n  padding: 3px 10px;\n  border-radius: 999px;\n  background: #e7f5f2;\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #0d9b87;\n  white-space: nowrap;\n}\n\n.sto-pill.is-warn {\n  background: #fbf3e4;\n  color: #c98a16;\n}\n\n/* Existing controls (leaves) */\n.sto-leaves {\n  list-style: none;\n  margin: 0;\n  padding: 4px 14px 12px 54px;\n  border-top: 1px dashed #e3eaee;\n}\n\n.sto-leaf {\n  display: flex;\n  gap: 10px;\n  padding: 8px 0;\n}\n\n.sto-leaf + .sto-leaf {\n  border-top: 1px solid #f0f4f6;\n}\n\n.sto-leaf-dot {\n  flex: none;\n  width: 8px;\n  height: 8px;\n  margin-top: 6px;\n  border-radius: 50%;\n  background: #0d9b87;\n}\n\n.sto-leaf-title {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.45;\n  overflow-wrap: anywhere;\n}\n\n.sto-leaf-desc {\n  margin: 2px 0 0;\n  font-size: 11.5px;\n  line-height: 1.5;\n  color: #5f7484;\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
